import {Link} from 'react-router-dom';
import Layout, {Titolo} from '../Layout';
import {getUser, hasRole} from '../api';

export default function HomePage() {
    const nome = getUser().googleUserInfo.given_name;

    return (
        <Layout>
            <Titolo>Ciao {nome}</Titolo>
            <div className="row g-3">
                <Scorciatoia to="/bolle-viaggianti" icon="bi-truck" titolo="Bolle"
                             testo="Bolle in viaggio verso i negozi e file per Passepartout."/>
                {hasRole('ROLE_ADMIN') && (
                    <>
                        <Scorciatoia to="/ordini" icon="bi-cart3" titolo="Ordini e-commerce"
                                     testo="Ordini del sito con righe, indirizzi, pagamento e fattura."/>
                        <Scorciatoia to="/clienti" icon="bi-people" titolo="Clienti e-commerce"
                                     testo="Clienti registrati sul sito e i loro ordini."/>
                        <Scorciatoia to="/fatture" icon="bi-receipt" titolo="Fatture e-commerce"
                                     testo="Fatture e note di credito: download XML/PDF e flag di invio."/>
                        <Scorciatoia to="/avvisi" icon="bi-exclamation-triangle" titolo="Avvisi"
                                     testo="Articoli in transito non presenti in Passepartout."/>
                        <Scorciatoia to="/amministrazione" icon="bi-gear" titolo="Amministrazione"
                                     testo="Download CSV ordini da AS400."/>
                    </>
                )}
            </div>
        </Layout>
    );
}

function Scorciatoia({to, icon, titolo, testo}) {
    return (
        <div className="col-12 col-md-6 col-lg-4">
            <Link to={to} className="scorciatoia h-100">
                <div className="card h-100">
                    <div className="card-body">
                        <i className={icon}></i>
                        <h5 className="card-title mt-2">{titolo}</h5>
                        <p className="card-text text-secondary mb-0">{testo}</p>
                    </div>
                </div>
            </Link>
        </div>
    );
}
